export default "__VITE_ASSET__Bb1APRAH__"